// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZzfonJBZuOskaPimGdcl {
    margin-top: 32px;
    margin-bottom: 32px;
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: 6px;

    && {
        padding: 40px;
    }
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/Telehealth/ExpiredRoomMessage/ExpiredRoomMessage.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;;IAER;QACI,aAAa;IACjB;AACJ","sourcesContent":[".container {\n    margin-top: 32px;\n    margin-bottom: 32px;\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    gap: 6px;\n\n    && {\n        padding: 40px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ZzfonJBZuOskaPimGdcl`
};
export default ___CSS_LOADER_EXPORT___;
